module.exports = __webpack_public_path__ + "assets/img/101901.5e6344a4.svg";